import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { unpublishEditoEventPath } from 'app/routes/edito';
import type { IEditoEventListResponse } from 'app/typings/edito';
import { apiMutation } from 'app/utils/request/api';

type PayloadProps = {
  id: string;
};

export const useUnpublishEditoEvents = () => {
  return useMutation<IEditoEventListResponse[], unknown, PayloadProps, unknown>(
    {
      mutationFn: async (payload: PayloadProps) =>
        apiMutation(
          'PATCH',
          {
            path: unpublishEditoEventPath,
            params: { id: payload.id },
          },
          payload
        ),
      onSuccess: () => {
        message.success('The event has been successfully unpublished');
      },
      onError: () => {
        message.error('Error while unpublishing the event');
      },
    }
  );
};
